import { useState } from "react";
interface ToggleProps {
//   register?: any;
//   errors?: any;
//   name?: string;
//   required?: boolean;
//   labelName?:string;
defaultChecked?:boolean;
className?:string
// tabIndex?:number;
status?:boolean;
handleToggleChange?: (status: any) => any;
}
export default function DashboardToggle(props:ToggleProps) {
  // const{register,errors,name,required,labelName,defaultChecked=true,tabIndex}=props
  const {status,defaultChecked=true,className}=props
  const [isChecked, setIsChecked] = useState(defaultChecked||false);
  const handleToggleChange = () => {
    const newCheckedState = !isChecked;
    setIsChecked(newCheckedState);
    props.handleToggleChange?.(newCheckedState);
  };
  const inputElement = (
    <input
      className="form-check-input cursor-pointer"
      type="checkbox"
      role="switch"
      id="flexSwitchCheckChecked"
      checked={isChecked} 
      onChange={handleToggleChange} 
    />
  );
  return (
    <>
     <label className="form-check-label me-1">Active</label>
     <div className="form-check form-switch sidebar-toggler">
        {inputElement}
        
      </div>
 </>
  );
}
